import { all, call, fork, put, takeEvery } from 'bukku/shared/SagaService';
import actions from './actions';
import AppActions from '../App/actions';
import { get, post } from 'bukku/shared/ApiService';
import {t} from "@lingui/macro";
import { message } from 'antd';

// Create product
export function* backupAttachmentsRequest() {
    yield takeEvery(actions.BACKUP_ATTACHMENTS_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            yield call(get, '/backup/attachments', request, context);

            // OK
            yield put({
                type: actions.BACKUP_ATTACHMENTS_SUCCESS,
            });
            yield message.success(t`Success! Please check your email for the attachments!`);
        }
        catch (error) {
            yield put({
                type: actions.BACKUP_ATTACHMENTS_ERROR,
                error,
            });
            yield message.error(error.message);
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}

// Create product
export function* backupDatabaseRequest() {
    yield takeEvery(actions.BACKUP_DATABASE_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            yield call(post, '/backup/database', request, context);

            // OK
            yield put({
                type: actions.BACKUP_DATABASE_SUCCESS,
            });
            yield message.success(t`Success! Please check your email for the database!`);
        }
        catch (error) {
            yield put({
                type: actions.BACKUP_DATABASE_ERROR,
                error,
            });
            yield message.error(error.message);
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}

export default function* rootSaga() {
    yield all([
        fork(backupAttachmentsRequest),
        fork(backupDatabaseRequest),
    ]);
}
